<template>
  <svg
    viewBox="0 0 21 21"
    class="icon-arrow-toggle"
    :class="{
      'is-flipped': open,
    }"
  >
    <rect
      x="9"
      y="1"
      width="3"
      height="16"
      fill="currentColor"
      class="icon-arrow-toggle-stem delay-200"
    />

    <rect
      x="2"
      y="8.28"
      width="8.5"
      height="4"
      class="icon-arrow-toggle-left fill-current"
    />

    <rect
      x="10.5"
      y="8.28"
      width="8.5"
      height="4"
      class="icon-arrow-toggle-right fill-current"
    />
  </svg>
</template>

<script setup lang="ts">
defineProps<{
  open?: boolean
}>()
</script>

<style lang="postcss">
.icon-arrow-toggle {
  --skew: 42.2deg;
  --y: 0px;

  &.is-flipped {
    --skew: -40.6deg;
    --skew: -42.2deg;
    --y: 1px;
    .icon-arrow-toggle-stem {
      transform: translateY(3px);
    }
  }

  rect {
    transition: inherit;
  }
}

.icon-arrow-toggle-left {
  transform-origin: 2px 0;
  transform: skewY(calc(var(--skew))) translateY(var(--y));
}

.icon-arrow-toggle-right {
  transform-origin: 19px 0;
  transform: skewY(calc(var(--skew) * -1)) translateY(var(--y));
}
</style>
